import React from 'react';

export default function RiskDisclaimer() {
  return (
    <div className="min-h-screen w-full bg-white text-gray-800 py-12 px-4">
      <div className="max-w-5xl mx-auto space-y-12">
        {/* Header */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-extrabold text-purple-500">
            Risk Disclaimer
          </h1>
          <p className="text-lg text-gray-600">
            Million2Trillion (M2T) operates as a global verified-business and
            market-network platform. We do not provide trading, investment, or
            financial advisory services of any kind.
          </p>
        </div>

        {/* Body */}
        <div className="bg-white border border-purple-100 rounded-2xl shadow p-8 space-y-6 text-lg text-gray-700">
          <p>
            The Million2Trillion platform connects verified professionals,
            educators, organizations, and service providers within the global
            market ecosystem. All interactions, offers, or information shared
            through the platform are the independent responsibility of the
            respective parties.
          </p>

          <p>
            Any educational content, insights, strategies, or third-party tools
            accessible on M2T are provided solely for informational and
            networking purposes. They do not constitute financial advice or a
            solicitation to trade, invest, or engage in regulated financial
            activity.
          </p>

          <p>
            Million2Trillion does not endorse or guarantee the accuracy,
            performance, or legitimacy of any third-party content, product, or
            claim shared by users or contributors. Users must perform their own
            due diligence before acting upon any information.
          </p>

          <p>
            Market conditions, regulatory changes, and other external factors
            can significantly impact business or financial outcomes. All users
            engage with the platform and its members at their own discretion and
            risk.
          </p>

          <p>
            Million2Trillion, its founders, team, and verified partners shall
            not be held liable for any direct or indirect losses, damages, or
            liabilities resulting from communication, collaboration, or
            decisions made through this platform.
          </p>

          <p>
            M2T provides a secure and trusted gateway for verified users and
            businesses to communicate safely. However, we cannot control or
            guarantee the conduct, credibility, or compliance of independent
            participants beyond the verification layer.
          </p>

          <p>
            By using Million2Trillion, you acknowledge and accept that all
            interactions, business engagements, and participation within market
            ecosystems involve independent judgment and potential risk outside
            the control of the platform.
          </p>
        </div>
      </div>
    </div>
  );
}
